import { useEffect, useState } from "react";
import { Button } from "@bloom/ui";
import { useLocale } from "../locale/locale-context.tsx";

const KEY = "bloom-cookie-consent";

export function CookieConsent() {
  const { locale } = useLocale();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const value = localStorage.getItem(KEY);
    if (!value) setOpen(true);
  }, []);

  if (!open) return null;

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setOpen(false);
    window.dispatchEvent(new CustomEvent("bloom-consent-changed", { detail: "accepted" }));
  };
  const reject = () => {
    localStorage.setItem(KEY, "rejected");
    setOpen(false);
    window.dispatchEvent(new CustomEvent("bloom-consent-changed", { detail: "rejected" }));
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-4 bottom-4 z-40 max-w-md rounded-2xl bg-[var(--brand-ink)] p-4 text-[var(--brand-paper)] shadow-xl sm:left-4 sm:inset-x-auto"
    >
      <p className="text-sm leading-relaxed">
        {locale === "th"
          ? "เราใช้คุกกี้เพื่อวัดผลและพัฒนาประสบการณ์การใช้งาน คุณยอมรับหรือไม่?"
          : "We use cookies to measure and improve your experience. Accept?"}
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <Button variant="ghost" size="sm" onClick={reject} className="text-white">
          {locale === "th" ? "ปฏิเสธ" : "Reject"}
        </Button>
        <Button variant="rose" size="sm" onClick={accept}>
          {locale === "th" ? "ยอมรับ" : "Accept"}
        </Button>
      </div>
    </div>
  );
}
